import React from "react";
import "./AuditTrailStyles.scss";
import { Spin, Steps } from "antd";
import { formatDateTime } from "../../helpers/utils";
import { useSelector } from "react-redux";
import Loader from "../../components/Common/Loader";

const AuditTrail = ({ auditData, loading }) => {
  const { Step } = Steps;

  return (
    <div className="activiy-log-container">
      <h1 className="activiy-log-header">Activity Log</h1>
      {loading ? (
        <Loader showSpin />
      ) : (
        <>
          <section className="question">Q. {auditData?.question}</section>
          <div className="form-progress"></div>
          {auditData?.category && (
            <h2 className="category">{auditData?.category}</h2>
          )}
          <Steps
            progressDot
            current={100}
            direction="vertical"
            className={`${
              auditData?.category ? "sub-category-steps" : "steps"
            }`}
          >
            {auditData?.trail_data &&
              auditData?.trail_data.map((trail) => {
                return (
                  <Step
                    key={trail?.created_at}
                    title={
                      <div className="description-wrapper">
                        <span
                          className="activity-log-description"
                          dangerouslySetInnerHTML={{ __html: trail?.answer }}
                        ></span>
                        <span className="date">
                          {formatDateTime(trail?.created_at)}
                        </span>
                      </div>
                    }
                    description={<span className="user">by {trail?.user}</span>}
                  />
                );
              })}
          </Steps>
        </>
      )}
    </div>
  );
};

export default AuditTrail;
